module.exports = __webpack_public_path__ + "img/live1.7758c8c1.gif";